// extracted by mini-css-extract-plugin
module.exports = {"TextHorizontalScrolling":"styles_TextHorizontalScrolling__Z1_NN","text":"styles_text__COPvG","isWhite":"styles_isWhite__FSH3c"};